export const FOOTER_EVENTS = {
  FOOTER_SELECT_SOCIAL_MEDIA: "web_select_footer_social_media",
  FOOTER_SELECT_GO_LANDING: "web_go_to_sumer_landing",
  FOOTER_SELECT_APP_STORE: "web_select_app_store",
  FOOTER_SELECT_LINK: "select_link",
  SELECT_CONTACT_VENDOR: "web_select_contact_vendor",
  SELECT_SUPPORT_REQUEST: "web_select_support_request",
};
